export default "__VITE_ASSET__Bz5AX3ML__"